<script lang="ts" setup>
import { Loading } from '@element-plus/icons-vue'
</script>

<template>
    <el-menu-item :disabled="true">
        <el-icon class="is-loading">
            <Loading />
        </el-icon>
        <template #title>
            <span>Loading...</span>
        </template>
    </el-menu-item>
</template>
